<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>

		<b-row class="mt-3">

			<b-col cols="12">
				<b-form-group>
					<b-form-textarea
						id="note"
						v-model="note"
						placeholder="Enter note..."
						rows="3"
						max-rows="3"
					></b-form-textarea>
				</b-form-group>
			</b-col>

			<b-col cols="12" class="mb-3">
				<b-form-group label="Flag note">
					<b-form-checkbox
						id="flagged"
						v-model="flag"
						switch
						variant="danger"
						:value="true"
						:unchecked-value="false"
						size="lg"
					>
					</b-form-checkbox>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<b-button
					type="submit"
					variant="info"
				>
					Add Note
				</b-button>
			</b-col>

		</b-row>

	</b-form>
</template>


<script>
import LogService from "@/api-services/log.service";

export default {
	name: "AddNote",

	// things we have inherited from our parent
	props: ["entityType", "entityId"],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			note: "",
			flag: false,
		};
	},

	// things we do to data
	methods: {
		add() {
			let vm = this;

			let log = {
				EntityId:  vm.entityId,
				EntityType:  vm.entityType,
				Note:  vm.note,
				
			};

			LogService.create(log)
				.then((response) => {
					// push this sucka back to the parent
					let newNote = response.data;

					newNote.Flag = vm.flag
					vm.$emit("addNote", newNote);
				})
				.catch((error) => {
					console.log(error);
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-task-note.vue